( function ( _s ) {
	_s.fn.digitalExperienceModal = function () {
		return this.el.forEach( modal => {
			const _modal = _s( modal );
			const modalContent = modal.querySelector( '.de-modal-content' );
			const _modalContent = _s( modalContent );
			const _closeModal = _modal.find( '.de-close-modal' );

			const checkModalDescriptionHeight = () => {
				_modalContent.css( 'height', '' );

				const modalHeight = modal.offsetHeight;
				const modalContentHeight = modalContent.offsetHeight;
				const heightDiff =
					_modalContent.offset().top +
					modalContentHeight -
					( _modal.offset().top + modalHeight );

				if ( heightDiff > 0 ) {
					_modalContent.css( 'height', `${ modalContentHeight - heightDiff }px` );
				}
			};

			const videoSlidesInit = _slider => {
				const slider = window.splideInstances[ _slider.attr( 'id' ) ];
				const _videoSlides = _modal.find( '.video-slide' );

				const playPauseVideo = ( iframe, status ) => {
					if ( iframe.contentWindow ) {
						// Pause Youtube Videos
						if ( iframe.src.startsWith( 'https://www.youtube.com' ) ) {
							iframe.contentWindow.postMessage(
								'{"event":"command","func":"' +
									( status === 'play' ? 'playVideo' : 'pauseVideo' ) +
									'","args":""}',
								'*'
							);
						}
						// Pause Vimeo Videos
						if ( iframe.src.startsWith( 'https://player.vimeo.com/' ) ) {
							iframe.contentWindow.postMessage(
								'{"method":"' + ( status === 'play' ? 'play' : 'pause' ) + '"}',
								'*'
							);
						}
					}
				};

				slider.on( 'move', function () {
					_videoSlides.each( videoSlide => {
						playPauseVideo( videoSlide, 'pause' );
					} );
				} );

				// _videoSlides.each( videoSlide => {
				// 	const _videoSlideContainer = _s( videoSlide ).closest( '.splide__slide' );

				// 	_videoSlideContainer.on( 'mousedown', e => {
				// 		console.log( 'mousedown e.clientX ' + e.clientX );
				// 	} );

				// 	_videoSlideContainer.on( 'mouseup', e => {
				// 		console.log( 'mouseup e.clientX ' + e.clientX );
				// 	} );

				// 	_videoSlideContainer.on( 'mousemove', e => {
				// 		console.log( 'mousemove e.clientX ' + e.clientX );
				// 	} );
				// } );
			};

			_closeModal.on( 'click keyup', e => {
				if (
					( e.type == 'keyup' && ( e.key === 'Enter' || e.keyCode === 13 ) ) ||
					e.type == 'click'
				) {
					_modal.removeClass( 'show' );
					_modal.trigger( 'fr:modal-closed' );
				}
			} );

			if ( _modal.find( '.video-slide' ).length ) {
				const _slider = _modal.find( '.splide' );
				const sliderId = _slider.attr( 'id' );

				if ( window?.splideInstances?.[ sliderId ] ) {
					videoSlidesInit();
				} else {
					_slider.on( 'fr:splide-instance-added', () => {
						videoSlidesInit( _slider );
					} );
				}
			}

			checkModalDescriptionHeight();

			_s( window ).on( 'resize', () => {
				checkModalDescriptionHeight();
			} );

			_s( window ).on( 'load', () => {
				checkModalDescriptionHeight();
			} );
		} );
	};

	_s( document ).ready( () => {
		_s( '.digital-experience-modal' ).digitalExperienceModal();
	} );
} )( window._s );
